import styled from 'styled-components';
import { SuccessIcon } from 'foundations-assets/icons/components/SuccessIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const ColorButton = styled.button.withConfig({
  displayName: "ColorPicker__ColorButton",
  componentId: "v8dwfo-0"
})(["align-items:center;display:flex;position:relative;width:36px;height:36px;border-radius:50%;background-image:", ";justify-content:center;text-align:center;border:0;margin-right:12px;"], props => props.gradient);
export default function ColorPicker({
  onClick,
  gradient,
  selected
}) {
  return /*#__PURE__*/_jsx(ColorButton, {
    onClick: onClick,
    gradient: gradient,
    children: selected && /*#__PURE__*/_jsx(SuccessIcon, {
      size: "400",
      color: "fill-surface-default"
    })
  });
}